import { makePromoFetchRequestAction, makePromoSubmitAction } from 'state/promo/actions';
import { PromoDialogProps } from './types';
import { PromoDto } from 'types';
import { PromoForm } from 'forms/PromoForm/PromoForm';
import { useAction, useActionDispatchOnMount } from 'core/store/store';
import { useCallback } from 'react';
import { useRouterParam } from 'core/router/router';
import { useSelector } from 'react-redux';
import i18n from '../../../../../i18n';
import { DialogNew } from '../../../../components/Dialog/DialogNew';

export const VendorPromoEditDialog = (props: PromoDialogProps) => {
    const { onClose } = props;
    const { t } = i18n.useTranslation();

    const action = useAction();
    const promoId = useRouterParam('promoId');
    useActionDispatchOnMount(true, (promoId: string) => makePromoFetchRequestAction(promoId), promoId);
    const promo: PromoDto = useSelector((state: any) => state.promo.promo);
    const currentPromo = promo && promo.promoId === promoId ? promo : null;
    let formInitialValues = null;
    if (currentPromo) {
        const { conditions, description, image, results, active } = promo;
        formInitialValues = {
            minOrderPrice: conditions.minOrderPrice,
            deliveryType: conditions.deliveryType,
            discountType: (results && results[0].discountType) || null,
            discount: (results && results[0].discount) || 0,
            discountedItemId: (results && results[0].discountedItemId) || null,
            image,
            description,
            active,
        };
    }

    const handleSubmit = useCallback((data: unknown) => action(makePromoSubmitAction, data, promoId), [promoId]);
    return (
        <DialogNew disableContentPadding title={t('vendor:promos.edit.dialogTitle')} onClose={onClose}>
            {formInitialValues && (
                <PromoForm initialValues={formInitialValues} onClose={onClose} isEditable onSubmit={handleSubmit} />
            )}
        </DialogNew>
    );
};
